import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Switch,
    FormControlLabel,
    IconButton,
    Divider,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";

import { useParams, useNavigate } from "react-router-dom";

import { rtdb, storage } from "../../services/firebase";
import { ref, get, set } from "firebase/database";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";


import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

export default function EditProduct() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [nome, setNome] = useState("");
    const [descricao, setDescricao] = useState("");
    const [marca, setMarca] = useState("");
    const [categoria, setCategoria] = useState("");
    const [preco, setPreco] = useState("");
    const [isPromo, setIsPromo] = useState(false);
    const [precoPromo, setPrecoPromo] = useState("");
    const [variacoes, setVariacoes] = useState([{ nome: "", quantidade: "" }]);
    const [specs, setSpecs] = useState([{ key: "", value: "" }]);

    const [imagens, setImagens] = useState([]);

    const [estoqueOpen, setEstoqueOpen] = useState(false);

    useEffect(() => {
      carregarMarcasECategorias();
    }, []);

    useEffect(() => {
      if (!loadingData) {
        loadProduct();
      }
    }, [id, loadingData]);

    async function carregarMarcasECategorias() {
      try {
        const appSnap = await get(ref(rtdb, "app"));
        if (appSnap.exists()) {
          const data = appSnap.val();
          setBrands(Array.isArray(data.brands) ? data.brands.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
          setCategories(Array.isArray(data.category) ? data.category.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
        }
      } catch (err) {
        console.error("Erro ao carregar marcas e categorias:", err);
      } finally {
        setLoadingData(false);
      }
    }

    async function loadProduct() {
      setLoading(true);
      try {
        const snap = await get(ref(rtdb, `products/${id}`));

        if (snap.exists()) {
          const p = snap.val();

          setNome(p.nome);
          setDescricao(p.descricao);
          setMarca(p.marca);
          setCategoria(p.categoria);
          setPreco(p.precos?.normal || "");
          setIsPromo(p.precos?.isPromo || false);
          setPrecoPromo(p.precos?.promo || "");
          setVariacoes(p.variacoes || []);
          setSpecs(p.specs || []);

          // 🔥 imagens estruturadas
          setImagens(
            (p.imagens || []).map((url) => ({
              id: crypto.randomUUID(),
              url,
              isNew: false
            }))
          );
        }
      } catch (err) {
        console.error("Erro ao carregar produto:", err);
      } finally {
        setLoading(false);
      }
    }

    async function handleSave() {

      if (imagens.length < 1 || imagens.length > 5) {
        alert("O produto deve ter entre 1 e 5 imagens.");
        return;
      }

      setSaving(true);

      try {
        const imageUrls = await processImages();

        const updated = {
          id,
          nome,
          descricao,
          marca,
          categoria,
          variacoes,
          specs,
          imagens: imageUrls, // 🔥 ORDEM PRESERVADA
          precos: {
            normal: preco,
            isPromo,
            promo: isPromo ? precoPromo : null
          }
        };

        await set(ref(rtdb, `products/${id}`), updated);

        alert("Produto atualizado com sucesso!");

        navigate("/admin/produtos");

      } catch (err) {
        console.error(err);
        alert("Erro ao salvar produto");
      }

      setSaving(false);

    }

    function handleImages(e) {
      const files = Array.from(e.target.files);

      if (files.length + imagens.length > 5) {
        alert("Máximo 5 imagens");
        return;
      }

      const novas = files.map((file) => ({
        id: crypto.randomUUID(),
        url: URL.createObjectURL(file),
        file,
        isNew: true
      }));

      setImagens([...imagens, ...novas]);
    }

    function removeImage(imageId) {
      setImagens(imagens.filter(img => img.id !== imageId));
    }

    async function processImages() {
      const finalUrls = [];

      for (const img of imagens) {
        if (!img.isNew) {
          finalUrls.push(img.url);
          continue;
        }

        const imageRef = storageRef(
          storage,
          `products/${id}/${img.id}`
        );

        await uploadBytes(imageRef, img.file);
        const downloadURL = await getDownloadURL(imageRef);

        finalUrls.push(downloadURL);
      }

      return finalUrls;
    }

    const formatMoney = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, "");
        value = (value / 100).toFixed(2).replace(".", ",");
        return "R$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    if (loading)
        return <Typography sx={{ ml: 32, mt: 10 }}>Carregando...</Typography>;

    return (
        <Box sx={{ ml: 32, mt: 4, pr: 4 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                Editar Produto — {id}
            </Typography>

            <Paper sx={{ p: 4, borderRadius: 3 }}>

                <Grid container spacing={3} alignItems="center">

                    {/* ID */}
                    <Grid item xs={12} md={3}>
                        <TextField label="ID" value={id} fullWidth disabled />
                    </Grid>

                    {/* Nome */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Nome do Produto"
                            fullWidth
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>

                    {/* Marca */}
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth sx={{
                            width: 300,
                            "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                            "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                        }}>
                            <InputLabel>Marca</InputLabel>
                            <Select
                                value={marca}
                                onChange={(e) => setMarca(e.target.value)}
                                disabled={loadingData}
                            >
                                {brands.map((b) => (
                                    <MenuItem key={b.id} value={b.nome}>{b.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Categoria */}
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth sx={{
                            width: 300,
                            "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                            "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                        }}>
                            <InputLabel>Categoria</InputLabel>
                            <Select
                                value={categoria}
                                onChange={(e) => setCategoria(e.target.value)}
                                disabled={loadingData}
                            >
                                {categories.map((c) => (
                                    <MenuItem key={c.id} value={c.nome}>{c.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Descrição */}
                    <Grid item xs={12}>
                        <TextField
                            label="Descrição do Produto"
                            fullWidth
                            multiline
                            minRows={4}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            sx={{
                                minWidth: 500,
                                maxWidth: 600,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>
                </Grid>



                <Divider sx={{ my: 4 }} />

                {/* ====================== VARIAÇÕES ====================== */}

                <Typography variant="h6" sx={{ mb: 2 }}>
                    Variações / Sabores / Cores
                </Typography>

                {variacoes.map((v, i) => (
                    <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Variação"
                                fullWidth
                                value={v.nome}
                                onChange={(e) => {
                                    const arr = [...variacoes];
                                    arr[i].nome = e.target.value;
                                    setVariacoes(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                label="Quantidade"
                                fullWidth
                                value={v.quantidade}
                                onChange={(e) => {
                                    const arr = [...variacoes];
                                    arr[i].quantidade = e.target.value.replace(/\D/g, "");
                                    setVariacoes(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={() => setVariacoes(variacoes.filter((_, idx) => idx !== i))}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setVariacoes([...variacoes, { nome: "", quantidade: "" }])}>
                    Adicionar Variação
                </Button>

                <Divider sx={{ my: 4 }} />

                {/* ====================== PREÇOS ====================== */}

                <Typography variant="h6" sx={{ mb: 2 }}>
                    Valores do Produto
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Preço"
                            fullWidth
                            value={preco}
                            onChange={(e) => setPreco(formatMoney(e.target.value))}
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControlLabel
                            control={<Switch checked={isPromo} onChange={(e) => setIsPromo(e.target.checked)} />}
                            label="Promoção?"
                        />
                    </Grid>

                    {isPromo && (
                        <Grid item xs={12} md={3}>
                            <TextField
                                label="Preço Promocional"
                                fullWidth
                                value={precoPromo}
                                onChange={(e) => setPrecoPromo(formatMoney(e.target.value))}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>
                    )}
                </Grid>

                <Divider sx={{ my: 4 }} />

                {/* ====================== ESPECIFICAÇÕES ====================== */}

                <Typography variant="h6" sx={{ mb: 2 }}>
                    Especificações
                </Typography>

                {specs.map((s, i) => (
                    <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="Título"
                                fullWidth
                                value={s.key}
                                onChange={(e) => {
                                    const arr = [...specs];
                                    arr[i].key = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Valor"
                                fullWidth
                                value={s.value}
                                onChange={(e) => {
                                    const arr = [...specs];
                                    arr[i].value = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={() => setSpecs(specs.filter((_, idx) => idx !== i))}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setSpecs([...specs, { key: "", value: "" }])}>
                    Adicionar Especificação
                </Button>

                <Divider sx={{ my: 4 }} />

                {/* ====================== IMAGENS ====================== */}

                <Stack direction="row" spacing={2} flexWrap="wrap">
                  {imagens.map((img) => (
                    <Box key={img.id} sx={{ position: "relative" }}>
                      <img
                        src={img.url}
                        alt=""
                        style={{ width: 100, height: 100, borderRadius: 8, objectFit: "cover" }}
                      />
                      <IconButton
                        size="small"
                        onClick={() => removeImage(img.id)}
                        sx={{ position: "absolute", top: -10, right: -10, bgcolor: "white" }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Stack>

                <Button variant="outlined" component="label" sx={{ mt: 1 }}>
                    Selecionar Imagens
                    <input hidden type="file" multiple accept="image/*" onChange={handleImages} />
                </Button>

                {/* ====================== BOTÃO SALVAR ====================== */}

                <Box sx={{ mt: 4, textAlign: "right" }}>
                    <Button variant="contained" size="large" onClick={handleSave} disabled={saving}>
                        {saving ? "Salvando..." : "Salvar Alterações"}
                    </Button>
                </Box>
            </Paper>

            {/* ====================== POPUP DE ESTOQUE ====================== */}

            <Dialog open={estoqueOpen} onClose={() => setEstoqueOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Estoque das Variações</DialogTitle>

                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Variação</TableCell>
                                <TableCell>Quantidade</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {variacoes.map((v, i) => (
                                <TableRow key={i}>
                                    <TableCell>{v.nome}</TableCell>
                                    <TableCell>{v.quantidade}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setEstoqueOpen(false)}>Fechar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
